package co.maytes.standupbot.dashboard.features.settings

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.components.widgets.DatePicker
import co.maytes.standupbot.dashboard.components.widgets.Select
import co.maytes.standupbot.dashboard.components.widgets.SelectOption
import co.maytes.standupbot.dashboard.components.widgets.TextInput
import co.maytes.standupbot.dashboard.styles.Spacing
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import org.jetbrains.compose.web.css.cssRem

private data class ActionNamespace(val value: String, val label: String)

private val NAMESPACES = listOf(
    ActionNamespace("", "All actions"),
    ActionNamespace("integration.", "integration.*"),
    ActionNamespace("team.", "team.*"),
    ActionNamespace("standup.", "standup.*"),
    ActionNamespace("auth.", "auth.*"),
    ActionNamespace("workspace.", "workspace.*"),
)

private val ACTION_WIDTH = 11.cssRem
private val ACTOR_WIDTH = 12.cssRem
private val DATE_WIDTH = 9.cssRem

@Composable
fun AuditLogFilters(
    filter: AuditFilter,
    actors: List<ActorChoice>,
    query: String,
    onQueryChange: (String) -> Unit,
    onChange: (AuditFilter) -> Unit,
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .styleModifier {
                property("flex-wrap", "wrap")
                property("gap", Spacing.sm.toString())
            },
        verticalAlignment = Alignment.Bottom,
    ) {
        SettingsField(
            label = "Search",
            modifier = Modifier.styleModifier {
                property("flex", "1 1 14rem")
                property("min-width", "12rem")
            },
        ) {
            TextInput(
                value = query,
                onValueChange = onQueryChange,
                placeholder = AuditLogView.SEARCH_PLACEHOLDER,
                ariaLabel = "Search the loaded events",
                modifier = Modifier.fillMaxWidth(),
            )
        }
        SettingsField(label = "Action", modifier = Modifier.width(ACTION_WIDTH)) {
            Select(
                value = filter.actionPrefix ?: "",
                options = NAMESPACES.map { SelectOption(it.value, it.label) },
                onValueChange = { v -> onChange(filter.copy(actionPrefix = v.takeIf { it.isNotBlank() })) },
                modifier = Modifier.fillMaxWidth(),
                ariaLabel = "Filter by action",
            )
        }
        SettingsField(label = "Actor", modifier = Modifier.width(ACTOR_WIDTH)) {
            Select(
                value = filter.actorUserId ?: "",
                options = listOf(SelectOption("", "Anyone")) + actors.map { SelectOption(it.userId, it.displayName) },
                onValueChange = { v -> onChange(filter.copy(actorUserId = v.takeIf { it.isNotBlank() })) },
                modifier = Modifier.fillMaxWidth(),
                ariaLabel = "Filter by actor",
            )
        }
        SettingsField(label = "From", modifier = Modifier.width(DATE_WIDTH)) {
            DatePicker(
                value = filter.since ?: "",
                onChange = { raw -> onChange(filter.copy(since = raw.takeIf { it.isNotBlank() })) },
                modifier = Modifier.fillMaxWidth(),
                ariaLabel = "Events from",
            )
        }
        SettingsField(label = "To", modifier = Modifier.width(DATE_WIDTH)) {
            DatePicker(
                value = filter.until ?: "",
                onChange = { raw -> onChange(filter.copy(until = raw.takeIf { it.isNotBlank() })) },
                modifier = Modifier.fillMaxWidth(),
                ariaLabel = "Events up to",
            )
        }
    }
}

data class ActorChoice(val userId: String, val displayName: String)
